import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Firebase project: hoja-copilot
// Keys are non-secret client config — safe to commit.
// Actual access is controlled by Firestore security rules.
const firebaseConfig = {
  apiKey: "AIzaSyCWl5PzPW2Aeh_gYd_Uiypwhjp3EMkwjU8",
  authDomain: "hoja-copilot.firebaseapp.com",
  projectId: "hoja-copilot",
  storageBucket: "hoja-copilot.appspot.com",
  messagingSenderId: "135321878115",
  appId: "1:135321878115:web:8c79e26cea8fdc9b99c256"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export default app;
